import { ofType } from 'redux-observable';
import { mergeMap, map, filter } from 'rxjs';
import { AppEpic } from 'src/store';
import { of } from 'rxjs';
import { inputIsNotNullOrUndefined, isScopeDefined } from 'src/utils/Functions/epicsFunctions';
import {
  fetchCompanionListData,
  updateSelectedItem,
  updateSelectedLevel,
  receiveWorklistConfig,
  cleanUp,
} from './Worklist.slice';
import { receiveFilterStateAfterSubmission } from 'src/components/FilterPanel/FilterPanel.slice';
import {
  receiveScope,
  receiveScopeRefreshTrigger,
} from 'src/components/AssortmentScopeSelector/AssortmentScopeSelector.slice';
import {
  ConfDefnComponentType,
  WorklistComponent,
  maybeGetComponentProps,
} from 'src/services/configuration/codecs/confdefnComponents';
import { isNil } from 'lodash';
import { preSetActivePage } from '../NavigationShell/NavigationShell.slice';
import { GroupViewItem } from 'src/services/configuration/codecs/viewdefns/general';
import { Action } from 'redux';

// Separate config loading from level selection. Config load triggers
// the selected level (which the the relevant part for data fetching).
export const worklistConfigLoaded: AppEpic = (action$, state$) => {
  return action$.pipe(
    ofType(receiveWorklistConfig.type),
    map(() => maybeGetComponentProps<WorklistComponent>(state$.value, ConfDefnComponentType.worklist)),
    filter(inputIsNotNullOrUndefined),
    mergeMap(() => {
      const { viewDefn } = state$.value.worklist;
      // TODO: this needs to be a filter condition through pipe instead of returning a blank "action" here
      if (viewDefn == null) return of();

      const restore = state$.value.breadcrumbs.activeBreadcrumbRestore;

      // setup levelBy selection
      const levelByOptions: GroupViewItem[] = viewDefn.companionView.levelBy?.view ?? [];
      const defaultLevelByDataIndex = viewDefn.companionView.levelBy?.defaults.dataIndex;
      let selectedLevel: GroupViewItem | undefined;

      // attempt to select levelby by priority (from restore > viewdefn default > first option)
      if (restore?.selectedLevel) {
        // attempt to set restore
        selectedLevel = levelByOptions.find((lb) => lb.dataIndex === restore.selectedLevel);
      }
      if (defaultLevelByDataIndex && selectedLevel == null) {
        // attempt to set configured default value
        selectedLevel = levelByOptions.find((lb) => lb.dataIndex === defaultLevelByDataIndex);
      }
      if (levelByOptions.length > 0 && selectedLevel == null) {
        // set first option as selection
        selectedLevel = levelByOptions[0];
      }

      let actions: Action[] = [updateSelectedLevel(selectedLevel)];
      // setup item selection
      if (restore?.selectedCompanionId) {
        actions.push(updateSelectedItem(restore?.selectedCompanionId));
      }
      return of(...actions);
    }),
  );
};

export const worklistCompanionLoad: AppEpic = (action$, state$) => {
  return action$.pipe(
    ofType(
      receiveFilterStateAfterSubmission.type,
      receiveScopeRefreshTrigger.type,
      updateSelectedLevel.type,
      receiveWorklistConfig.type,
      'LENS_ASST_PLAN_REFRESHING_PAGE',
      receiveScope.type,
    ),
    map(() => maybeGetComponentProps<WorklistComponent>(state$.value, ConfDefnComponentType.worklist)),
    filter(inputIsNotNullOrUndefined),
    filter(props => !props.hideCompanion), // don't even try and load the companion if `hideCompanion = true`
    filter(() => isScopeDefined(state$.value.scope)),
    mergeMap(({ defns }) => {
      const { selectedLevel, viewDefn } = state$.value.worklist;

      if (isNil(viewDefn)) {
        return of();
      }
      const levelBy = viewDefn.companionView.levelBy;
      if (!isNil(levelBy) && isNil(selectedLevel)) {
        return of();
      } else {
        return of(fetchCompanionListData(defns.model, { aggBy: selectedLevel?.groupingKey }));
      }
    }),
  );
};

export const worklistCompanionReset: AppEpic = (action$) => {
  return action$.pipe(
    ofType(preSetActivePage.type),
    mergeMap(() => {
      return of(cleanUp());
    }),
  );
};
